import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { Base64 } from 'js-base64';

Vue.use(VueAxios, axios);

// 导入封装的回调函数
import { setting } from '../config/config';






/**
 * 封装axios的通用请求
 * @param  {string}   type      get或post
 * @param  {string}   url       请求的接口URL
 * @param  {object}   data      传的参数，没有则传空对象
 * @param  {Function} fn        回调函数
 * @param  {boolean}  tokenFlag 是否需要携带token参数，为true，不需要；false，需要。一般除了登录，都需要
 * @param  {boolean}  isLoadingShow 是否需要显示Loading
 * @param  {int}  version 接口版本号
 */
export default function({
	type,
	path,
	data,
	fn,
	headers,
	opts,
	isLoadingShow,
	tokenFlag,
	version,
	upLoadData,		//如果是上传文件，文件数据存放
	finallyFn,		
  isExport,		//是否是导出接口,
	urlData,		//url路径中带参
} = {}) {

	// 动态设置本地和线上接口域名
	Vue.axios.defaults.baseURL = setting.mockData ? setting.mockbasePath : setting.basePath;

	//urlData将参数写入url
	if (urlData && urlData != null && urlData != undefined) {
		for (let key in urlData) {
			path = path.replace('{' + key + '}', urlData[key]);
		}
	}

	var options = {
		method: type,
		url: path,
		headers: headers && typeof headers === 'object' ? headers : {},
		isExport: isExport || false
	};

	// tokenFlag = tokenFlag == undefined || tokenFlag == null ? true : tokenFlag;
	// var token = tokenFlag ? this.$store.state.userInfo.token : null;
	// if (token!==null){
	// 	options.headers.authorization = token
	// }

	//如果是上传文件
	
	if(upLoadData){
		options.headers['Content-Type']= 'multipart/form-data';
		//options.headers.param = Base64.encode(JSON.stringify(dataObj),true);
		options['data'] = upLoadData;

	} else {
		//options.headers.param = '';
    options[type === 'get' || type === 'delete' ? 'params' : 'data'] = data;
	}
	

	// 分发显示加载样式任务
	let loadingInstance=null;
	if(isLoadingShow){
		loadingInstance=this.$loading({fullscreen:true,text:""});
	}

	//axios内置属性均可写在这里
	if (opts && typeof opts === 'object') {
		for (var f in opts) {
			options[f] = opts[f];
		}
	}


	//ajax请求接口
	if (!options.isExport) {

		//发送请求
		Vue.axios(options).then((res) => {

			if (loadingInstance != null && loadingInstance != undefined) {
				loadingInstance.close();
			}
	
			if (res.data.code === 0) {
				fn(res.data.data || undefined);
			} else {
				if (res.data.code === -2 ) {
					if (loadingInstance != null && loadingInstance != undefined) {
						loadingInstance.close();
					}
					this.$store.dispatch('remove_userinfo').then(() => {
						this.$router.push({ path: '/login' });
					});
				
				} else {
					this.$message.error(res.data.msg);
					if (finallyFn && typeof (finallyFn) === "function") {
						finallyFn(res.data);
					}
				}
			}
		
		
		}).catch((err) => {
			console.log(err);
			if (loadingInstance != null && loadingInstance != undefined) {
				loadingInstance.close();
			}
			this.$message.error(err.message);

			if (finallyFn && typeof (finallyFn) === "function") {
				finallyFn(undefined);
			}
		});
	} else { 
	  //发送请求
		// Vue.axios(options).then((res) => {
		// 	if (loadingInstance != null && loadingInstance != undefined) {
		// 		loadingInstance.close();
		// 	}
		// 	fn(res.data,res.headers)
		// }).catch((err) => {
		// 	console.log(err);
		// 	if (loadingInstance != null && loadingInstance != undefined) {
		// 		loadingInstance.close();
		// 	}
		// 	this.$message.error(err.message);

		// 	if (finallyFn && typeof (finallyFn) === "function") {
		// 		finallyFn(undefined);
		// 	}
		// });
    let preform = document.getElementById('exportIframeForm');
    if (preform) {
      document.body.removeChild(preform)
    }
    var myForm = document.createElement("form");
    myForm.id = "exportIframeForm"
    // myForm.target = "exportIframe";
    // myForm.action = Vue.axios.defaults.baseURL + options.url;
    // myForm.method = 'post';
    var myiframe = document.createElement("iframe");
    myiframe.setAttribute('name', 'exportIframe');
    myiframe.setAttribute('style', 'display:none');
    myiframe.setAttribute('src', Vue.axios.defaults.baseURL + options.url);
    myForm.appendChild(myiframe);
    document.body.appendChild(myForm);
    document.myiframe
	}
};
